
import React, { Component } from 'react';
import { Col } from 'react-bootstrap';

class KeyAccountManagerDetails extends Component {
  render() {
    const { keyAccountFirstName, keyAccountLastName, keyAccountEmail } = this.props;

    return (
        <Col className="col-lg-6 personal--details">
          <h4>Key Account Manager</h4>
          <table id="personal--details">
          <tr>
              <td className="col-form-label">First Name</td>
              <td className="col-form-data readonly">{keyAccountFirstName}</td>
          </tr>
          <tr>
              <td className="col-form-label">Last Name</td>
              <td className="col-form-data readonly">{keyAccountLastName}</td>
          </tr>
          <tr>
              <td className="col-form-label">Email</td>
              <td className="col-form-data readonly">{keyAccountEmail}</td>
          </tr>
          </table>
        </Col>
    );
  }
}

export default KeyAccountManagerDetails;



// WEBPACK FOOTER //
// ./src/components/my-profile/key-account-manager-details.jsx